import { inIframe } from './trail_helpers';
import { LanguageSupportUtil } from './language_support_util';

function modalSignup(ref, returnTo, languageRegionCode) {
  window.onbeforeunload = null; // remove prompts before leaving page

  const isMobile = typeof navigator !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  // If on mobile or in iframe always go to full page
  if ((isMobile || inIframe()) && window && window.top) {
    window.top.location = LanguageSupportUtil.wrapUrlSafe(`/signup?returnTo=${returnTo}&ref=${ref}`, languageRegionCode);
    return false;
  }
  if (window) {
    window.location = LanguageSupportUtil.wrapUrlSafe(`/signup?returnTo=${returnTo}&ref=${ref}`, languageRegionCode);
  }
  return false;
}

function modalPro(ref, returnTo, languageRegionCode) {
  window.onbeforeunload = null; // remove prompts before leaving page

  const isMobile = typeof navigator !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  // If on mobile or in iframe always go to full page
  if ((isMobile || inIframe()) && window && window.top) {
    window.top.location = LanguageSupportUtil.wrapUrlSafe(`/plus?returnTo=${returnTo}&ref=${ref}`, languageRegionCode);
    return false;
  }
  if (window) {
    window.location = LanguageSupportUtil.wrapUrlSafe(`/plus?returnTo=${returnTo}&ref=${ref}`, languageRegionCode);
  }
  return false;
}

export { modalSignup };
export { modalPro };
